jQuery(function ($) {
  const sections = $('[data-cards]');

  $.each(sections, function () {
    const section = $(this);
    const grid = section.find('[data-grid]');

    grid.colcade({
      columns: '.grid-col',
      items: '.grid-item'
    });

  });
});
